import { Lookup } from '../../../vas/business-objects/lookup/lookup.model';
import * as actions from './text-control-mobile-modal.actions';

export interface State {
    lookups: Array<Lookup>;
    searchTerm: string;
}

export const initialState: State = {
    lookups: [],
    searchTerm: ''
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state: State = initialState, action: actions.Actions): State {

    switch (action.type) {
        case actions.DESTROY: {
            return {
                ...initialState
            };
        }
        case actions.INIT_SUCCESS: {
            return {
                ...state,
                lookups: [...action.payload.lookups]
                    .sort((a, b) =>
                        a.title.localeCompare(b.title)
                    )
            };
        }
        case actions.SET_SEARCH_TERM: {
            return {
                ...state,
                searchTerm: action.payload.searchTerm
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modals-popovers/text-control-mobile-modal/text-control-mobile-modal.reducer.ts